import React from 'react';
import { useAuth } from 'src/hooks/useAuth';

/** @registry Resolves the first top-level module route the current user may open; use for home/fallback redirects. */
export function useHomeRoute(): string {
  const { checkFeatureAllowed, user } = useAuth();

  return React.useMemo(() => {
    if (checkFeatureAllowed(['modules_all', 'ctc'])) return '/ctc';
    if (checkFeatureAllowed(['modules_all', 'jobs'])) return '/jobs';
    if (checkFeatureAllowed(['modules_all', 'activity_feed']))
      return '/activity';
    if (checkFeatureAllowed(['modules_all', 'operations']))
      return '/operations';
    if (checkFeatureAllowed(['modules_all', 'time'])) return '/time';
    if (checkFeatureAllowed(['modules_all', 'reports'])) return '/reports';
    if (checkFeatureAllowed(['modules_all', 'manhours'])) return '/manhours';
    return '/jobs';
  }, [user]);
}
